import isFunction from 'lodash/isFunction'
// 空函数
export function noop () {}

// 空函数 返回空Promise
export function noopPremise () {
  return Promise.resolve()
}
// 克隆
export function clone (obj) {
  return JSON.parse(JSON.stringify(obj))
}
// 空函数 参数原样返回
export function noopReturn (...args) {
  return { ...args }
}

export function s2o (str) {
  let obj = {}
  if (typeof str === 'string') {
    try {
      // eslint-disable-next-line no-eval
      obj = eval(`(${str})`)
    } catch (error) {}
  }
  return obj
}

// 简单拷贝
export function copy (obj) {
  return JSON.parse(JSON.stringify(obj))
}

// 获取对象类型
export function getType (val) {
  return Object.prototype.toString
    .call(val)
    .toLocaleLowerCase()
    .slice(1, -1)
    .split(' ')[1]
}

// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_get
export function get (obj, path, defaultValue = undefined) {
  const travel = regexp =>
    String.prototype.split
      .call(path, regexp)
      .filter(Boolean)
      .reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj)
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/)
  return result === undefined || result === obj ? defaultValue : result
}

// 深度对比 https://github.com/alibaba/form-render/blob/master/src/base/utils.js
export function isDeepEqual (param1, param2) {
  if (param1 === undefined && param2 === undefined) return true
  else if (param1 === undefined || param2 === undefined) return false
  else if (param1.constructor !== param2.constructor) return false

  if (param1.constructor === Array) {
    if (param1.length !== param2.length) return false
    for (let i = 0; i < param1.length; i++) {
      if (param1[i].constructor === Array || param1[i].constructor === Object) {
        if (!isDeepEqual(param1[i], param2[i])) return false
      } else if (param1[i] !== param2[i]) return false
    }
  } else if (param1.constructor === Object) {
    if (Object.keys(param1).length !== Object.keys(param2).length) return false
    for (let i = 0; i < Object.keys(param1).length; i++) {
      const key = Object.keys(param1)[i]
      if (
        param1[key] &&
        typeof param1[key] !== 'number' &&
        (param1[key].constructor === Array ||
          param1[key].constructor === Object)
      ) {
        if (!isDeepEqual(param1[key], param2[key])) return false
      } else if (param1[key] !== param2[key]) return false
    }
  } else if (param1.constructor === String || param1.constructor === Number) {
    return param1 === param2
  }
  return true
}

// 判断参数是Promise对象
// https://stackoverflow.com/questions/27746304/how-do-i-tell-if-an-object-is-a-promise
export function isNativePromise (p) {
  return p && typeof p.constructor === 'function' &&
    Function.prototype.toString.call(p.constructor).replace(/\(.*\)/, '()') === Function.prototype.toString.call(Function)
      .replace('Function', 'Promise')
      .replace(/\(.*\)/, '()')
}

// 将参数包装为 Promise 对象
export function parsePromise (obj) {
  if (obj && isNativePromise(obj)) {
    return obj
  }
  return Promise.resolve(obj)
}

export function callApi (params) {
  let that = this
  let { filterFn, fetchFn, mappingFn, failFn, successFn, query } = params
  let filterResult = filterFn.call(this, { body: query })
  let deferFilterResult = parsePromise(filterResult)
  return new Promise(function (resolve, reject) {
    let catchFn = function (err) {
      failFn && isFunction(failFn) && failFn.call(that, err)
      reject(err)
    }
    deferFilterResult.then(function (queryParams = {}) {
      let fetchResult = fetchFn.call(that, queryParams)
      let deferResult = parsePromise(fetchResult)
      deferResult.then(function (result = {}) {
        let jsonResult = mappingFn.call(that, result)
        let deferJson = parsePromise(jsonResult)
        deferJson.then(function (json = {}) {
          successFn && isFunction(successFn) && successFn.call(that, json)
          resolve(json)
        }).catch(catchFn)
      }).catch(catchFn)
    }).catch(catchFn)
  })
}

// 四位随机数
export function s4 () {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
}

// guid
export function guid () {
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

export function generateDeferredPromise () {
  return (() => {
    let res
    let rej
    let p = new Promise((resolve, reject) => {
      res = resolve
      rej = reject
    })
    return {
      promise: p,
      reject: rej,
      resolve: res
    }
  })()
}

// 首字母大写
export const firstUpperCase = ([first, ...rest]) => first?.toUpperCase() + rest.join('')

// 当前标准时间
export function format (fmt) {
  var toDay = new Date(fmt)
  // var year = toDay.getFullYear()
  var month = toDay.getMonth() + 1 < 10 ? '0' + (toDay.getMonth() + 1) : toDay.getMonth() + 1
  var data = toDay.getDate() < 10 ? '0' + toDay.getDate() : toDay.getDate()
  var hour = toDay.getHours() < 10 ? '0' + toDay.getHours() : toDay.getHours()
  var minute = toDay.getMinutes() < 10 ? '0' + toDay.getMinutes() : toDay.getMinutes()
  var second = toDay.getSeconds() < 10 ? '0' + toDay.getSeconds() : toDay.getSeconds()
  var today = month + '/' + data + ' ' + hour + ':' + minute + ':' + second
  return today
}
